import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { MessagesScreenAction } from 'redux/reducers/messagesReducer';

export const endSearch = (
  reason: Error | string | null
): Action<MessagesScreenAction, Error | string | null> =>
  createAction(MessagesScreenAction.endSearch, reason);
